import React from 'react';
import { useTranslation } from 'next-i18next';

import type { Props as ButtonProps } from 'src/components/ui/Button';
import Button from 'src/components/ui/Button';
import IconButton from 'src/components/ui/IconButton';
import Icon from 'src/components/ui/Icon';
import stopPropagation from 'src/utils/stopPropagation';
import useAuthenticatedRedirect from 'src/hooks/useAuthenticatedRedirect';
import { routePathContactsWithUserId } from 'src/constants/router';
import useDynamicLogEvents from 'src/hooks/useDynamicLogEvents';
import { AnalyticsEvent } from 'src/utils/analytics';

interface Props extends ButtonProps {
    userId: string;
    iconOnly?: boolean;
}

const ChatButton: React.FC<Props> = ({ userId, iconOnly = false, ...buttonProps }) => {
    const { t } = useTranslation(['common']);
    const authenticatedRedirect = useAuthenticatedRedirect();
    const { logEventDynamic } = useDynamicLogEvents();

    const handleChatClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        logEventDynamic(AnalyticsEvent.ClickChat);

        e.stopPropagation();
        e.preventDefault();

        await authenticatedRedirect(`${routePathContactsWithUserId}${userId}`);
    };
    const iconName = buttonProps.variant === 'contained' ? 'ChatWhiteInactive' : 'ChatPrimaryInactive';
    return !iconOnly ? (
        <Button
            startIcon={<Icon size="1.33rem" style={{ margin: '-0.125rem' }} name={iconName} />}
            onMouseDown={stopPropagation}
            onClick={handleChatClick}
            variant="outlined"
            {...buttonProps}
        >
            {t('common:contact')}
        </Button>
    ) : (
        <IconButton
            iconProps={{ name: iconName, size: '1.25rem' }}
            onMouseDown={stopPropagation}
            onClick={handleChatClick}
            color="primary"
        />
    );
};

export default ChatButton;
